import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { adminLocationHref } from '../../config/adminHost';
import { ADMIN_PATHS, adminPath } from '../../constants/adminPaths';
import '../styles/adminLoginPage.css';

function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(name);
  if (value) return value;

  const match = window.location.href.match(new RegExp(`[?&]${name}=([^&]*)`));
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

/**
 * Intercepts auth action links and redirects to the admin panel's
 * custom handlers (same pattern as the main app's ActionLinkHandler).
 */
const AdminActionLinkHandler = () => {
  const [error, setError] = useState('');
  const [message, setMessage] = useState('Redirecting…');

  useEffect(() => {
    const mode = getQueryParam('mode');
    const oobCode = getQueryParam('oobCode');

    if (!mode || !oobCode) {
      setMessage('');
      setError('This link is invalid or expired.');
      return;
    }

    if (mode === 'resetPassword') {
      const params = new URLSearchParams({ mode, oobCode });
      const target = `${adminLocationHref('/reset-password')}?${params.toString()}`;
      setMessage('Redirecting to password reset…');
      window.location.replace(target);
      return;
    }

    setMessage('');
    setError('This action is not supported.');
  }, []);

  return (
    <div className="adminLogin">
      <div className="adminLogin__bg" aria-hidden="true" />
      <main className="adminLogin__container">
        <section className="adminLogin__card" aria-label="Account action">
          <header className="adminLogin__header">
            <div className="adminLogin__badge" aria-hidden="true">
              Admin
            </div>
            <h1 className="adminLogin__title">{error ? 'Link error' : 'One moment'}</h1>
            <p className="adminLogin__subtitle">
              {error || message}
            </p>
          </header>

          {error ? (
            <div className="adminLogin__alert" role="alert">
              <span className="adminLogin__alertDot" aria-hidden="true" />
              <span>{error}</span>
            </div>
          ) : (
            <div className="adminLogin__loadingWrap" aria-busy="true">
              <span className="adminLogin__spinner" aria-hidden="true" />
            </div>
          )}

          {error ? (
            <footer className="adminLogin__footer">
              <RouterLink className="adminLogin__secondaryLink" to={adminPath(ADMIN_PATHS.LOGIN)}>
                Back to sign in
              </RouterLink>
            </footer>
          ) : null}
        </section>
      </main>
    </div>
  );
};

export default AdminActionLinkHandler;
